import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { getAProduct, getRelatedProducts } from '../features/products/productSlice';
import loader from "../images/loader/loader1.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PiEngineFill } from "react-icons/pi";
import { FaCar } from "react-icons/fa";
import { FaRoad } from "react-icons/fa";
import { RiSteering2Fill } from "react-icons/ri";


const RelatedProducts2 = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const location = useLocation();
  const navigate = useNavigate();

   const relatedProducts = useSelector((state) => state.product.relatedProducts);
  const dispatch = useDispatch();
 const getProductSlug = location.pathname.split("/")[2];

  useEffect(() => {
    dispatch(getAProduct(getProductSlug));
    dispatch(getRelatedProducts(getProductSlug));
  }, [dispatch, getProductSlug]);

const handleProductView = (product) => {
  if (product.availability === "Out of Stock") return;
  navigate(`/vehicle/${product.slug}`);
};
  return (
    <section className="related-products-wrapper flex-column justify-content-center d-flex w-100">
      <div className={`related-products-collection${isDesktop ? ' row w-100' : ''}`}>
        {relatedProducts.map((item) => (
          <div
            key={item._id}
            className="product-card position-relative "
            onClick={() => handleProductView(item.slug)}
            style={{ cursor: "pointer" }}
          >
            <div className="product-image">
                {item?.availability === "Out of Stock" && (
                  <div className="sold-badge">
                    SOLD
                  </div>
                )}
              <LazyLoadImage
                alt={item?.title}
                effect="blur"
                src={item?.images[0]?.url || loader}
                placeholderSrc={loader}
                width="100%"
                height={isDesktop ? 180 : "100%"}
                className="img-fluid mx-auto img-el"
              />
            </div>
            <div className="product-details">
              <h5 className="product-title ellipsis" >
                {item?.title}
              </h5>
            <div className="features">
              <span className="feature-item">
                <RiSteering2Fill className="feature-icon"/> 
                <span className="feature-text">{item?.transmission}</span>
              </span>

              <span className="feature-item">
                <PiEngineFill className="feature-icon"/> 
                <span className="feature-text">{item?.engineSize[0]?.title}</span>
              </span>

              <span className="feature-item">
                <FaCar className="feature-icon"/> 
                <span className="feature-text">{item?.yom}</span>
              </span>

              <span className="feature-item">
                <FaRoad className="feature-icon"/> 
                <span className="feature-text">{item?.fuelType}</span>
              </span>
            </div>

                    <div className="price-wrapper">
                      <p className="nw-price">KES {item?.price.toLocaleString()}</p>
                    {item?.availability === "Out of Stock" ? (
                    <button className="sold-button" disabled>
                      <span>Sold</span>
                    </button>
                  ) : (
                    <button className="view-button">
                      <span>Details</span>
                    </button>
                  )}
                    </div>

             
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RelatedProducts2;
